module.exports = __webpack_public_path__ + "static/media/image07.43136704.png";